var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.subtitle)+" "),_c('v-select',{attrs:{"items":_vm.options,"label":_vm.label,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }